import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../lib/lang";

export default function Footer() {
  const { t } = useLang();

  return (
    <footer className="wrap" data-testid="app-footer">
      <span>{t("Brand & Behavior® — Barcelona, Spain", "Brand & Behavior® — Barcelona, España")}</span>
      <a href="mailto:hello@brandandbehavior.com" data-testid="footer-email">hello@brandandbehavior.com</a>
      <Link to="/about" data-testid="footer-about">{t("About", "Sobre")}</Link>
      <Link to="/terms" data-testid="footer-terms">{t("Terms & Policies", "Términos y políticas")}</Link>
      <Link to="/faq" data-testid="footer-faq">FAQ</Link>
      <span>2026</span>
    </footer>
  );
}
